import Application from "../../Application";
import { IStore } from "../../model/runtime/state/Store";
import { IPortalMenuItemService } from "../../service/menu/PortalMenuItemService";

export default class LoadMenuItemsInteractor {
  private application: Application;
  private portalMenuItemService: IPortalMenuItemService;
  private store: IStore;

  constructor(application, store, portalMenuItemService) {
    this.application = application;
    this.portalMenuItemService = portalMenuItemService;
    this.store = store;
  }

  async execute(languageCode) {
    const menuItems = await this.portalMenuItemService.getAllMenuItems(
      languageCode
    );

    this.store.update({
      menuItems
    });
  }
}
